import type {PostHog} from 'posthog-js';

/**
 * Returns the PostHog JS SDK client, or null when running server-side or the SDK
 * hasn't been initialized (e.g. the plugin skipped it). No localhost guard —
 * the plugin already handles that gracefully.
 */
export const getPostHogClient = (): PostHog | null => {
  if (!import.meta.client) return null;
  try {
    const nuxtApp = useNuxtApp();
    const $posthog = nuxtApp.$posthog as (() => PostHog) | undefined;
    return $posthog?.() ?? null;
  } catch {
    return null;
  }
};
